import { Grid } from '@mui/material';
import { RoutalLoader } from '@nx-smartmonkey/ui';
import { PlanOverviewListContainer } from './PlanOverviewListStyles';

export const PlanOverviewListLoading = () => {
  return (
    <PlanOverviewListContainer wrap="nowrap" container direction="column" style={{ overflow: `hidden` }}>
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ height: `100%`, width: `100%` }}
      >
        <RoutalLoader />
      </Grid>
    </PlanOverviewListContainer>
  );
};
